"use client";

import Link from "next/link";
import { useMemo, useState } from "react";
import { InstagramCard } from "@/app/components/instagram-card";
import { formatDateTime } from "@/lib/format";
import { purchasePath } from "@/lib/instagram";

type EventItem = {
  slug: string;
  title: string;
  address: string;
  dates: string[];
  instagram_url: string;
};

export function EventCatalog({ events }: { events: EventItem[] }) {
  const [query, setQuery] = useState("");
  const filtered = useMemo(
    () =>
      events.filter(
        (event) =>
          !query ||
          `${event.title} ${event.instagram_url} ${event.address}`
            .toLocaleLowerCase("es")
            .includes(query.toLocaleLowerCase("es")),
      ),
    [events, query],
  );
  return (
    <>
      <section className="card catalog-filters" aria-label="Filtrar cartelera">
        <label>
          Buscar
          <input
            type="search"
            placeholder="Obra, Instagram o lugar"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
          />
        </label>
      </section>
      <section className="grid" aria-label="Eventos publicados">
        {filtered.map((event) => (
          <article className="card card-accent" key={event.slug}>
            <h2>{event.title}</h2>
            <InstagramCard url={event.instagram_url} title={event.title} />
            <p>
              {event.dates.length
                ? `${formatDateTime(event.dates[0])} · ${event.dates.length} fecha(s)`
                : "Fechas próximamente"}
            </p>
            <p>{event.address}</p>
            <Link className="button" href={purchasePath(event.slug)}>
              Elegir entradas
            </Link>
          </article>
        ))}
        {!filtered.length && (
          <p className="empty">No hay eventos que coincidan con tu búsqueda.</p>
        )}
      </section>
    </>
  );
}
